import React, { Component } from 'react';
import { Growl } from "primereact/growl";
import { Accordion, AccordionTab } from 'primereact/accordion';
import PerfilCliente from "../componentes/PerfilCliente";
import UsuarioCliente from "../componentes/UsuarioCliente";

export class ConfiguracionSeguridad extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    mostrarTab = (indiceTab) => {
        switch (indiceTab.index) {
            case 0:
                this.setState({ tabPerfil: <PerfilCliente /> });
                this.setState({ tabUsuario: null });                
                break;
            case 1:
                this.setState({ tabPerfil: null });
                this.setState({ tabUsuario: <UsuarioCliente /> });                
                break;           
            default:
                break;
        }
    }

    ocultarTab = (indiceTab) => {
        this.setState({ tabPerfil: null });
        this.setState({ tabUsuario: null });        
    }

    render() {
        let { tabPerfil, tabUsuario } = this.state;
        return (
            <div className="p-grid">
                <Growl ref={(el) => (this.growl = el)} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Configuración de seguridad</h1>
                        <div className="p-fluid p-grid" >
                            <Accordion onTabOpen={this.mostrarTab} onTabClose={this.ocultarTab}>
                                <AccordionTab header="Perfiles">
                                    {tabPerfil}
                                </AccordionTab>
                                <AccordionTab header="Usuarios" >
                                    {tabUsuario}
                                </AccordionTab>                               
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}